import type { TableCellColor } from '@/types/report-payload';

type TableCellColorOption = {
    key: TableCellColor;
    hex: string;
    label: string;
};

/**
 * Text colors offered for a table cell, alongside the default ink.
 *
 * Coloring text has a limit that coloring a background does not: a light tone
 * makes the word disappear. All three clear 4.5:1 against white paper, which is
 * where the laudo ends up.
 */
export const TABLE_CELL_COLORS: TableCellColorOption[] = [
    { key: 'red', hex: '#BA1C1C', label: 'Vermelho' },
    { key: 'blue', hex: '#1D4ED8', label: 'Azul' },
    { key: 'green', hex: '#047756', label: 'Verde' },
];

/** The color a cell should be painted with, or `undefined` for the default ink. */
export const resolveTableCellColor = (color?: TableCellColor): string | undefined =>
    TABLE_CELL_COLORS.find((option) => option.key === color)?.hex;
